export default {
  'pages.orderList.title': '意向单列表',
  'pages.orderList.search.id': '订单编号',
  'pages.orderList.search.id.placeholder': '请输入订单编号',
  'pages.orderList.search.name': '发货单号',
  'pages.orderList.search.name.placeholder': '请输入发货单号',
  'pages.orderList.search.name2': '产品名称',
  'pages.orderList.search.name2.placeholder': '请输入产品名称',
  'pages.orderList.search.name3': '产品编号',
  'pages.orderList.search.name3.placeholder': '请输入产品编号',
  'pages.orderList.search.date': '下单时间',
  'pages.orderList.search.date.placeholder1': '请选择开始时间',
  'pages.orderList.search.date.placeholder2': '请选择结束时间',
  'pages.orderList.header.info': '商品信息',
  'pages.orderList.header.craft': '单价',
  'pages.orderList.header.total': '小计（元）',
  'pages.orderList.header.quantity': '数量',
  'pages.orderList.header.operate': '操作',
  'pages.orderList.list.id': '订单编号',
  'pages.orderList.list.date': '期望交期',
  'pages.orderList.list.person': '下单人',
  'pages.orderList.modifyTimer.dialog.title': '修改期望交期',
  'pages.orderList.modifyTimer.dialog.ok': '提交',
  'pages.orderList.modifyTimer.dialog.cancel': '取消',
  'pages.orderList.deliver.dialog.title': '发货清单',
};
